// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__Bm2JO","linkAction":"styles_linkAction__p4IRs"};